import React, {Suspense} from 'react';
import {useParams} from "react-router-dom";
import '../index/IndexPage.css';
import LoadingContainer from "../../../../Common/component/LoadingContainer/LoadingContainer";

/*
import DemoDocViewer from "../../../../Docuwiz-service/DEMO/docView/DocView"
import DefaultDocViewer from "../../../../Docuwiz-service/Default/docView/DocView"
import PostechDocViewer from "../../../../Docuwiz-service/POSTECH/docView/DocView"
import BusanpaDocViewer from "../../../../Docuwiz-service/BUSANPA/docView/DocView"
 */

function DocViewPage() {

    const { openParam }       =    useParams() as { openParam: string };
    const { currentDocId }      =    useParams() as { currentDocId: string };
    const serviceCode:string           =    process.env.REACT_APP_SERVICE_NAME as string;
    const ComponentDocView = React.lazy(()=>import(`../../../../Docuwiz-service/Customer/${serviceCode}/docView/DocView`));

/*
    switch (serviceCode) {
        case 'DEFAULT':
            return (
                <DefaultDocViewer
                    openParam={openParam}
                    currentDocId={currentDocId}
                    serviceCode={`${serviceCode}DC`}
                />
            );
        case 'DEMO':
            return (
                <DemoDocViewer
                    openParam={openParam}
                    currentDocId={currentDocId}
                    serviceCode={`${serviceCode}DC`}
                />
            );
        case 'POSTECH':
            return (
                <PostechDocViewer
                    openParam={openParam}
                    currentDocId={currentDocId}
                    serviceCode={`${serviceCode}DC`}
                />
            );
        case 'BUSANPA':
            return (
                <BusanpaDocViewer
                    openParam={openParam}
                    currentDocId={currentDocId}
                    serviceCode={`${serviceCode}DC`}
                />
            );
        default:
            return <LoadingContainer message="문서를 불러오는 중..." />;
    }

 */
    return ComponentDocView     ?   <Suspense fallback={<LoadingContainer message="Loading Modules.." />}>
                                        <ComponentDocView   openParam={openParam} currentDocId={currentDocId} serviceCode={`${serviceCode}DC`} />
                                    </Suspense>
                                :   <LoadingContainer message="문서를 불러오는 중..." />;

};

export default DocViewPage;